<template>
  <div :class="modalTheme">
    <!-- <h3>WORK TEST</h3> -->
    <div :class="userStore.borderClass">
      <!-- <h3>WORK TEST</h3> -->
      <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->

      <!-- <h3>currentlySelectedRecords {{ currentlySelectedRecords }}</h3> -->
      <!-- :fields="fieldsRecordsArray" -->
      <!-- <h6 v-if="AreIdsShown" style="background: darkred; color: cyan">PIE: selectedWidgetFilter {{ selectedWidgetFilter }}</h6>
    <h4 v-if="AreIdsShown" style="background: darkgreen; color: white">filterDummyGrid(this.workwidgetArray) > {{ filterDummyGrid.length }}</h4>
    <h4 v-if="AreIdsShown" style="background: darkgoldenrod; color: yellow">workListStore..workwidgetArray{{ workListStore.workwidgetArray.length }}</h4> -->
      <!-- <h5  v-if="AreIdsShown" style="background:darkgreen;color:yellow;"> INC records{{ records.length }}</h5> -->
      <!-- <h5  v-if="AreIdsShown" style="background:darkgreen;color:yellow;"> INC arrayId  {{ arrayId }}</h5> -->

      <!-- <h6 v-if="AreIdsShown" style="background: red; color: white">selectedFileName {{ selectedFileName }}</h6> -->

      <!-- currentSelectedWorkSummaryWidget {{ currentSelectedWorkSummaryWidget.sourceType }} {{ currentSelectedWorkSummaryWidget.sourceId }} -->
      <!-- <h5  v-if="AreIdsShown" >TODO add EVENT @recordsSelected="recordsSelectedWidgetWork"</h5> -->

      <!-- <h3 style="color: red">WidgetRecordSelector</h3> -->
      <WidgetRecordSelector
        idField="id"
        :records="workListStore.workwidgetArray"
        :selectedFileName="selectedFileName"
        :selected="currentlySelectedRecords"
        @recordsSelected="recordsSelectedWidgetWorkLocal"
        @postTaskStatusRefresh="sendRefreshToParent"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, reactive } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { useStoreWorkList } from "@/stores/workListsStore";

import Blank from "@/modules/Patient/VisitSummaryMedsGrid.vue";

import WidgetRecordSelector from "@/modules/WorkLists/WidgetRecordSelector.vue";

// & COMPOSIBLEs
import { discreteDataDashMixin } from "@/use/discreteDataDashMixin.js";

// & PROPS
const props = defineProps({
  records: {
    type: Object,
    default: () => {},
  },
  selectedFileName: {
    type: String,
    default: () => {},
  },
  arrayId: {
    type: Number,
    default: () => {},
  },
});

const workListStore = useStoreWorkList();

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);

// * EMITTER
const emit = defineEmits(["refreshToParent"]);

// &  ARROW SYNTAX   () => {}
function greetOne() {
// console.clear();
// console.log(" Hello  from  greetOne()");
}

const greetTwo = () => {
// console.clear();
// console.log(" greetTwo()  says   `Hi`  ");
};

// some [] called names
// names.map(function(){
//   // ...  this is the old way
// })
// names.map((arg) => {
//   // ...  Arrow Syntax
//   return 'hello'
// })
// // * refactors TO >>>>
// names.map((arg) => 'hello')

// const filterDummyGrid2 = () => {
//   console.clear();
//   console.log("   () => {}  using  filterDummyGrid2() >>>>>>>>>>>>>>>>>>>>>>>>>>>>");
//   console.dir(props.records);

//   if (workListStore.selectedWidgetFilter !== "") {
//     return props.records.filter((record) => record.dueText == workListStore.selectedWidgetFilter);
//   } else {
//     return props.records;
//   }
// };

function sendRefreshToParent() {
  // emit("refreshToParent", true);
  // console.log("EMIT from WidgetSummaryDetailGridWork  sendRefreshToParent()  ---------refreshToParent");
}

function recordsSelectedWidgetWorkLocal(ids) {
  // console.log("recordsSelectedWidgetWorkFFRROMddMixN");
  // console.log("				GOES to discreteDATA MIXINS");
  // console.log();
// console.log("ids");
// console.log(ids);
// console.log(" SEND ids TO   USE     discDataDASHMinx  ");

// console.log("   FAAAIL   FAIL discDataDASHMinx             recordsSelectedWidgetWork");
  //  const xxx = recordsSelectedWidgetWork(ids);

  const { recordsSelectedWidgetWork } = discreteDataDashMixin(ids);

  const xxx = recordsSelectedWidgetWork(ids);
// console.log("xxx");
// console.log(xxx);

// console.log();
}

onMounted(() => {
  //   console.clear();
// console.log("onMounted() :     								  WidgetSummaryDetailGrid  WORK  >>>>");
// console.log(" prop   records ");
// console.log("props : ");
// console.log({ ...props });
// console.log({ ...props.records });
});
</script>


<style lang="scss" scoped>
@import "./worklistStyling.scss";

.dx-toolbar .dx-toolbar-items-container {
  height: 0rem !important;
}

.scroll-container,
.scroll-area {
  //max-width: 150px;
  height: 45px * 2;
  max-height: 45px * 4;
  //font-size: 30px;32
}

.scroll-container {
  overflow: auto;
  scroll-snap-type: y mandatory;
}

.scroll-area {
  scroll-snap-align: start;
}

.detailsSlot {
  border: 3px solid transparent;
}

.scroll-container,
.scroll-area {
  margin: 0 auto;
}

.scroll-area {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.scroll-area:nth-of-type(1) {
  background: #49b293;
}

.scroll-area:nth-of-type(2) {
  background: #c94e4b;
}

.scroll-area:nth-of-type(3) {
  background: #4cc1be;
}

.scroll-area:nth-of-type(4) {
  background: #8360a6;
}
</style>
